import I18nErrorMessage, {type I18nErrorMessageProps} from "./I18nErrorMessage";

/** ErrorIndicator forwards all props to {@link I18nErrorMessage}, but fixes the message width (className). */
type ErrorIndicatorProps = Omit<I18nErrorMessageProps, "className">;

/**
 * Indicator, that an error occurred.
 * @see I18nErrorMessage
 */
function ErrorIndicator(props: ErrorIndicatorProps) {
    return (
        <div className="grow-0 flex flex-col justify-center items-center">
            <I18nErrorMessage {...props} className="p-8" />
        </div>
    );
}

export default ErrorIndicator;
